var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-block text-xs font-semibold text-white text-small bg-alert-red"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }